export default __webpack_public_path__ + "static/media/pfp.5179e446.png";